import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {Provider} from "react-redux";
import {Toaster} from "sonner";
import App from "./App.tsx";
import {store} from "./dataStore/store.ts";
import "./index.css";

document.documentElement.classList.add("dark");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <App />
      <Toaster richColors theme="dark" />
    </Provider>
  </StrictMode>
);
